export const formatAttribute = (value: string) => {
    const regex = /^(.+?)((\.[\w]+)+)$/
    const match = value?.match(regex)
    const path = match?.[2] || ''

    return path
}
